<template>
    <div class="page_loader_cont" v-if="page_loading">
         <div class="spinner_height">
            <spinner-circle :black="true"></spinner-circle>
        </div>
    </div>
    <div v-if="ratings && !already_rated && !show_thanks_for_rating" class="conttte">
        <!-- Header -->
        <div class="header">
            <img v-if="ratings.company_logo" class="row img rating_logo" :src="linkk + '/' + ratings.company_logo" alt="logo">

            <p class="title">
                please rate the the employee<br />
                that serverd you :
            </p>
            <h3 class="branch" v-if="ratings.title">{{ ratings.title }}</h3>
        </div>
        <div class="column rating-page">

            <!-- branch rating -->
            <div v-if="ratings.company_logo && ratings.title" class="rating-card">
                <!-- use :src="linkk + '/' + ratings.company_logo as .avatar background image -->
                <div class="avatar" :style="{ backgroundImage: `url(${linkk}/${ratings.company_logo})` }"></div>

                <div class="info">
                    <div class="name-row">

                        <div class="name_and_role_and_stars_cont">
                            <div>
                                <h4 class="h_4_edit">{{ ratings.title }}</h4>
                            </div>
                            <!-- Stars -->
                            <StarsComp_ v-model="branch_rating_" @rated="branch_send_rating" />
                        </div>


                        <div class="row score none">
                            <img src="@/assets/normal_star.svg" alt="normal_star" class="normal_star"/> 
                            <div class="column">
                                <div v-if="ratings.branch_ratings.amazon_rating" class="rate_avg">{{ ratings.branch_ratings.amazon_rating }}</div>
                                <div v-else class="rate_avg">--</div>
                                <div v-if="ratings.branch_ratings.total_reviews" class="total_ratings">({{ ratings.branch_ratings.total_reviews }})</div>
                                <div v-else class="total_ratings">(--)</div>
                            </div>
                        </div>
                    </div>



                    <!-- Comment -->
                     <!--  v-model="item.comment" -->
                    <textarea v-model="branch_comment_" class="comment" placeholder="comment"></textarea>
                </div>
            </div>


            <!-- sales rating -->
            <div v-if="ratings.sales_user" class="rating-card">
                <!-- use :src="linkk + '/' + ratings.company_logo as .avatar background image -->
                <div class="avatar" :style="{ backgroundImage: `url(${linkk}/${ratings.sales_user.profile_pic})` }"></div>

                <div class="info">
                    <div class="name-row">

                        <div class="name_and_role_and_stars_cont">
                            <div>
                                <h4 class="h_4_edit">{{ ratings.sales_user.name }}</h4>
                                <span class="role" >Sales</span>
                            </div>
                            <!-- Stars -->
                            <StarsComp_ v-model="sales_rating_" @rated="sales_send_rating" />
                        </div>


                        <div class="row score none">
                            <img src="@/assets/normal_star.svg" alt="normal_star" class="normal_star"/> 
                            <div class="column">
                                <div v-if="ratings.sales_user.sales_ratings.amazon_rating" class="rate_avg">{{ ratings.sales_user.sales_ratings.amazon_rating }}</div>
                                <div v-else class="rate_avg">--</div>
                                <div v-if="ratings.sales_user.sales_ratings.total_reviews" class="total_ratings">({{ ratings.sales_user.sales_ratings.total_reviews }})</div>
                                <div v-else class="total_ratings">(--)</div>
                            </div>
                        </div>
                    </div>



                    <!-- Comment -->
                     <!--  v-model="item.comment" -->
                    <textarea v-model="sales_comment_" class="comment" placeholder="comment"></textarea>
                </div>
            </div>


            <!-- groomer rating -->
            <div v-if="ratings.groomer_user" class="rating-card">
                <!-- use :src="linkk + '/' + ratings.company_logo as .avatar background image -->
                <div class="avatar" :style="{ backgroundImage: `url(${linkk}/${ratings.groomer_user.profile_pic})` }"></div>

                <div class="info">
                    <div class="name-row">

                        <div class="name_and_role_and_stars_cont">
                            <div>
                                <h4 class="h_4_edit">{{ ratings.groomer_user.name }}</h4>
                                <span class="role" >Groomer</span>
                            </div>
                            <!-- Stars -->
                            <StarsComp_ v-model="groomer_rating_" @rated="groomer_send_rating" />

                        </div>


                        <div class="row score none">
                            <img src="@/assets/normal_star.svg" alt="normal_star" class="normal_star"/> 
                            <div class="column">
                                <div v-if="ratings.groomer_user.groomer_ratings.amazon_rating" class="rate_avg">{{ ratings.groomer_user.groomer_ratings.amazon_rating }}</div>
                                <div v-else class="rate_avg">--</div>
                                <div v-if="ratings.groomer_user.groomer_ratings.total_reviews" class="total_ratings">({{ ratings.groomer_user.groomer_ratings.total_reviews }})</div>
                                <div v-else class="total_ratings">(--)</div>
                            </div>
                        </div>
                    </div>



                    <!-- Comment -->
                     <!--  v-model="item.comment" -->
                    <textarea v-model="groomer_comment_" class="comment" placeholder="comment"></textarea>
                </div>
            </div>

            <!-- Cashier rating -->
            <div v-if="ratings.cashier_user" class="rating-card">
                <!-- use :src="linkk + '/' + ratings.company_logo as .avatar background image -->
                <div class="avatar" :style="{ backgroundImage: `url(${linkk}/${ratings.cashier_user.profile_pic})` }"></div>

                <div class="info">
                    <div class="name-row">

                        <div class="name_and_role_and_stars_cont">
                            <div>
                                <h4 class="h_4_edit">{{ ratings.cashier_user.name }}</h4>
                                <span class="role" >Cashier</span>
                            </div>
                            <!-- Stars -->
                            <StarsComp_ v-model="cashier_rating_" @rated="cashier_send_rating" />
                        </div>


                        <div class="row score none">
                            <img src="@/assets/normal_star.svg" alt="normal_star" class="normal_star"/> 
                            <div class="column">
                                <div v-if="ratings.cashier_user.cashier_ratings.amazon_rating" class="rate_avg">{{ ratings.cashier_user.cashier_ratings.amazon_rating }}</div>
                                <div v-else class="rate_avg">--</div>
                                <div v-if="ratings.cashier_user.cashier_ratings.total_reviews" class="total_ratings">({{ ratings.cashier_user.cashier_ratings.total_reviews }})</div>
                                <div v-else class="total_ratings">(--)</div>
                            </div>
                        </div>
                    </div>



                    <!-- Comment -->
                     <!--  v-model "item.comment" -->
                    <textarea v-model="cashier_comment_" class="comment" placeholder="comment"></textarea>
                </div>
            </div>



            <!-- Example usage of your data -->
            <!-- <div v-if="loading" class="loading">Loading...</div> -->
            <div v-if="error" class="error_msg d_error_msg">{{ error }}</div>

            <button class="submit" :disabled="logout_loading" @click="submitRatings">
                <div class="loading" v-if="submit_loading">
                    <Spinner />
                </div>
                <div class="btn_txt" v-else>Submit</div>
            </button>

        </div>
    </div>
   <div v-if="ratings && already_rated && !show_thanks_for_rating" class="column already_rated_cont">
        <div class="column status-card already_rated" id="ratedSection">

            <!-- <div class="status-card__icon">⭐</div> -->

            <h2 class="status-card__value">
                Already Rated
            </h2>

            <div class="status-card__subtitle">
                You have already rated this session.
            </div>

            <!-- <button class="status-card__action close_the_tab" @click="close_the_tab()">
                Close
            </button> -->

        </div>
    </div>

    <div v-if="show_thanks_for_rating" class="home_3">
        <ThanksForRating  />
    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex';
// import { mapActions } from 'vuex';
import request from '../axios_request';
// import Spinner from '@/components/Spinner.vue';
// import SocketioService from '@/services/socketio.service.js';
import StarsComp_ from '@/components/StarsComp_.vue';
import ThanksForRating from "@/components/ThanksForRating.vue";
import SpinnerCircle from './SpinnerCircle.vue';
import Spinner from '@/components/Spinner.vue';



export default {
    name: 'EmployeeRating',
    components: {
        StarsComp_,
        ThanksForRating,
        SpinnerCircle,
        Spinner
    },

    data() {
        return {
            page_loading: true,
            /* 🔹 YOUR DATA */
            already_rated: false,
            phone__: null,
            // loading: false,
            error: null,
            show_reset_form: false,
            line: null,
            linkk: process.env.VUE_APP_SERVER_ENDPOINT,
            logout_loading: false,
            magic_flag: false,
            rating_id__: null,

            ratings: null,
            branch_rating_: 0,
            branch_comment_: null,
            sales_rating_: 0,
            sales_comment_: null,
            groomer_rating_: 0,
            groomer_comment_: null,
            cashier_rating_: 0,
            cashier_comment_: null,

            show_thanks_for_rating: false,
            submit_loading: false,
        }
    },

    // mounted() {
    //     this.rating_id__  = this.$route.params.id;
    //     console.log('Rating ID:', this.rating_id__);
    // },

    created() {
        this.rating_id__  = this.$route.params.id;
        console.log('Rating ID:', this.rating_id__);
        // check ratind_id__ is not null then fetch data from server
        if (this.rating_id__ && this.rating_id__ !== null) {
            // Fetch rating data from server using rating_id__ send it as post request with rating_id__ = url_id
            console.log('Fetching rating data for ID:', this.rating_id__);
            // Example: You can use axios or fetch to get data from server
            request.post('/api/rating/get_by_url_id', { url_id: this.rating_id__ })
                .then(response => {
                    // Assuming response.data contains the ratings data
                    this.ratings = response.data;
                    console.log('Fetched rating data:', response);
                    if(this.ratings.submitted && this.ratings.submitted === true){
                        this.already_rated = true;
                    }
                    this.page_loading = false;
                })
                .catch(error => {
                    console.error('Error fetching rating data:', error);
                    this.error = 'Failed to load rating data. Please try again later.';
                    this.page_loading = false;
                });


        }









    },
    computed: {
        ...mapState([
            'phone',
            'parent_id',
            'first_time',
            'parent_name',
            'role',
            'company_logo'
        ]),
    },

    methods: {
        ...mapActions([
            "phone_",
            "parent_name_",
            "parent_id_",
            "first_time_",
            'set_logged_in',
            'role_',
            'company_logo_',
            'admin_name_'
        ]),
        branch_send_rating(value) {
            console.log('User rated Branch:', value)
        },
        sales_send_rating(value) {
            console.log('User rated Sales:', value)
        },
        groomer_send_rating(value) {
            console.log('User rated Groomer:', value)
        },
        cashier_send_rating(value) {
            console.log('User rated Cashier:', value)
        },
        onRated(value) {
            console.log('rating =', value)
            // هنا تبعت API
        },
        submitRatings() {
            if( this.submit_loading ){
                return;
            }
            this.error = null;
            this.submit_loading = true;

            if( !this.branch_rating_ || !this.sales_rating_ || !this.groomer_rating_ || !this.cashier_rating_ ) {
                this.error = 'Please provide ratings for all categories before submitting.';
                this.submit_loading = false;
                return;
            }

            // now submit all ratings and comments to server on this url /api/rating/submit_rating
            // send post request with branch_rating_, branch_comment_, sales_rating_, sales_comment_, groomer_rating_, groomer_comment_, cashier_rating_, cashier_comment_
            request.post('/api/rating/submit_rating', {
                url_id: this.rating_id__,
                branch_rate: this.branch_rating_,
                branch_comment: this.branch_comment_,
                sale_rate: this.sales_rating_,
                sales_comment: this.sales_comment_,
                groomer_rate: this.groomer_rating_,
                groomer_comment: this.groomer_comment_,
                cashier_rate: this.cashier_rating_,
                cashier_comment: this.cashier_comment_,
                groomer_id: this.ratings.groomer_user ? this.ratings.groomer_user.id : null,
            })
            .then(response => {
                console.log('Ratings submitted successfully:', response);
                // alert('Thank you for your feedback!');
                this.show_thanks_for_rating = true;
                this.already_rated = true;
                // Optionally, redirect or clear the form
            })
            .catch(error => {
                console.error('Error submitting ratings:', error);
                this.error = 'Failed to submit ratings. Please try again later.';
                this.submit_loading = false;
            });

            // console.log('Submitting Ratings:')
            // console.log('Branch Rating:', this.branch_rating_, 'Comment:', this.branch_comment_);
            // console.log('Sales Rating:', this.sales_rating_, 'Comment:', this.sales_comment_);
            // console.log('Groomer Rating:', this.groomer_rating_, 'Comment:', this.groomer_comment_);
            // console.log('Cashier Rating:', this.cashier_rating_, 'Comment:', this.cashier_comment_);
        },
        close_the_tab() {
            window.location.href = "about:blank";
            // window.close();
        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;600;700;800&display=swap');

.conttte{
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Nunito', Arial, sans-serif;
    margin: 50px 0px;
}

.rating-page {
    max-width: 500px;
    width: 100%;
    margin: auto;
    padding: 20px;
    /* font-family: Arial, sans-serif; */
    background-color: white;
    border-radius: 5px;
    border: #ccc 1px solid;

}

.header {
    /* text-align: center; */
    margin-bottom: 20px;
    max-width: 500px;
    width: 100%;
}

.logo {
    height: 60px;
}

.title {
    color: #666;
    font-size: 14px;
    margin: 10px 0px;
    font-size: 20px;
}

.branch {
    font-weight: bold;
    font-size: 20px;
    margin: 0px 0px;
}

.rating-card {
    display: flex;
    gap: 20px;
    padding: 15px 0;
    border-bottom: 1.5px solid #eee;
}

.rating-card:last-of-type {
    border-bottom: 0px solid #eee !important;
}

.avatar {
    /* background-color: #ddd; */
    width: 70px;
    height: 70px;
    border-radius: 50%;
    border-radius: 50%;
    background-size: cover;
    /* fill the circle */
    background-position: center;
    /* center the image */
    background-repeat: no-repeat;
    border: 1px solid #ccc;
}

.info {
    flex: 1;
}

.name-row {
    display: flex;
    justify-content: space-between;
}

.role {
    font-size: 16px;
    color: #888;
    font-weight: bold;
}

.stars {
    margin: 8px 0;
    font-size: 20px;
    cursor: pointer;
}

.stars span {
    color: #ccc;
}

.stars span.active {
    color: #f4c430;
}

.comment {
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

.submit {
    cursor: pointer;
    margin-top: 20px;
    padding: 12px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    width: fit-content;
    align-self: end;

    padding: 12px 25px;
    font-size: 16px;
    font-weight: bold;
    margin-top: 15px;
}

.loading {
    /* margin-top: 10px; */
    color: #007bff;
}

.error {
    margin-top: 10px;
    color: red;
}

.rating_logo {
    width: 25%;
    height: auto;
}

.h_4_edit{
    margin-top: 0px;
    margin-bottom: 0px;
    font-size: 20px;
}

.normal_star{
    height: 20px;
    margin-right: 5px;
}

.rate_avg{
    font-weight: bold;
}

.comment{
    color: #1d1d1d;
    border: 2px solid #CCCCCC;
    height: 80px;
    resize: vertical;
    min-height: 50px;
}

.comment::placeholder {
    color: #CCCCCC;
    font-size: 16px;
    font-weight: 400;
}

.ratting_star{
    height: 30px;
    margin-right: 5px;
}

.total_ratings {
    font-size: 13px;
    font-weight: bold;
    color: #6c6c6c;
}

.status-card{
    background-color: white;
    width: 100%;
    max-width: 500px;
    border-radius: 5px;
    border: 1px solid #ccc;
    padding: 10px 15px;
    margin-top: 10vh;
}

.already_rated_cont{
    align-items: center;
}

.close_the_tab{
    cursor: pointer;
    margin-top: 20px;
    padding: 12px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    width: fit-content;
    align-self: center;

    padding: 12px 25px;
    font-size: 16px;
    font-weight: bold;
    margin-top: 15px;
    align-self: flex-end;
}

.status-card__subtitle{
    font-size: 20px;
    margin-bottom: 1em;
}

.none{
    display: none !important;
}

</style>
